var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoGuthookIconOnly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 338 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.9,22.2C23.8,22,12.6,1.3,12.5,1.2c0-0.1-0.2-0.4-0.5-0.4c-0.3,0-0.5,0.3-0.5,0.4C11.4,1.3,0.1,22.2,0,22.3 S0,22.8,0.1,23s0.4,0.2,0.6,0.1C1,23,12,18.2,12,18.2S22.9,23,23.1,23c0.2,0.1,0.5,0.2,0.7-0.1C24.1,22.7,24,22.4,23.9,22.2z  M10.7,7.8v8.3l-6,2.6L10.7,7.8z M13.3,16.1V7.8l6,11L13.3,16.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGuthookIconOnly);
export default __webpack_public_path__ + "static/media/Logo_Guthook_Icon_Only.c779b048.svg";
export { ForwardRef as ReactComponent };